import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { GenericObject } from 'src/app/interfaces/generic-object';
import { GridActionColumnActions } from 'src/app/interfaces/grid-action-column-actions';
import { GridActionColumnMap } from 'src/app/interfaces/grid-action-column-map';
import { ToastService } from 'src/app/services/toast.service';

@Component({
  selector: 'app-vendor-ratings',
  templateUrl: './vendor-ratings.component.html',
  styleUrls: ['./vendor-ratings.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class VendorRatingsComponent {
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private ToastService: ToastService
  ) {
    this.route.paramMap.subscribe({
      next: (ParamMap) => {
        const CompanyId = Number(ParamMap.get('CompanyId'));

        if (!CompanyId) {
          throw this.ToastService.addErrorToast('Error', 'Missing Client Id.', {
            returnError: true
          });
        }

        Object.assign(this, { CompanyId });
      }
    });
  }

  CompanyId!: number;

  ColumnIdToColumnActions: GridActionColumnMap = {
    ['$actionColumn']: ['view']
  };

  SuppliedQueryData: GenericObject = {
    $and: [
      {
        $or: [
          { VendorId: { $ne: null } }
          // Need to develop page to allow ratings for Compliance Exempt Vendors
          // { ExemptVendorId: { $ne: null } }
        ]
      }
    ]
  };

  action({
    action,
    rowData
  }: {
    action: GridActionColumnActions;
    rowData: any;
  }) {
    if (action === 'view') {
      const { VendorId, ExemptVendorId } = rowData;

      const NavArrayParts: (string | number)[] = [
        'client',
        this.CompanyId,
        'vendors',
        'my-vendor'
      ];

      if (VendorId) {
        NavArrayParts.push(VendorId);
      }

      NavArrayParts.push('ratings');

      this.router.navigate(NavArrayParts);
    }
  }
}
